export default "__VITE_ASSET__BM8N73qL__";